<template>
  <v-container>
    <v-form :disabled="!currentUserCan('editAddresses')">
      <v-layout>
        <v-flex>
          <v-text-field
            v-model="address.employer"
            label="Employer Name"
            v-if="lookup('AddressType', address.addresstypeid) == 'Work'"
          />
          <v-text-field v-model="address.address1" label="Address Line 1" />
          <v-text-field v-model="address.address2" label="Address Line 2" />
          <v-text-field v-model="address.address3" label="Address Line 3" />
          <v-text-field
            v-model.number="address.postcode"
            label="Post Code"
            type="number"
          />
          <v-text-field v-model="address.city" label="City" />

          <v-text-field v-model="address.region" label="Region" />

          <!-- <lookup-select
          v-model="address.region"
          lookup-name="Regions"
          label="Region"
        /> -->
          <lookup-select
            v-model="address.countryid"
            lookup-name="Country"
            label="Country"
          />
          <lookup-select
            v-model="address.addresstypeid"
            lookup-name="AddressType"
            label="Address Type"
          />
          <v-layout wrap>
            <v-flex>
              <v-switch
                v-model.number="address.status"
                label="Active?"
              ></v-switch>
            </v-flex>
            <v-flex>
              <v-switch
                v-model.number="address.publish"
                label="Publish"
              ></v-switch>
            </v-flex>
            <v-flex xs1>
              <delete-item-button
                :disabled="!currentUserCan('editAddresses')"
                :itemid="address.addressid"
                :resourceid="address.addressid"
                url="addresses"
                @delete="
                  $emit('delete');
                  $store.dispatch('load');
                "
              />
            </v-flex>
          </v-layout>
        </v-flex>
      </v-layout>
      <v-btn
        v-if="showSaveButton == true && currentUserCan('editAddresses')"
        color="primary"
      >
        Save
      </v-btn>
    </v-form>
  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "AddressForm",
  props: {
    address: Object,
    showSaveButton: false
  },
  computed: {
    ...mapGetters({ lookup: "lookup" })
  }
};
</script>
